/* eslint-disable import/no-anonymous-default-export */
import {
  isUndefined,
  isEmpty,
  isNull,
  toString,
  size
} from 'lodash'

export default (value) => {
  const checkVal = toString(value)
  return (!isUndefined(checkVal) && !isEmpty(checkVal) && !isNull(checkVal) && size(checkVal) > 0)
}
